module.exports = __webpack_public_path__ + "1cdefc534ab45e08101dd891e7cf981e.jpg";